import { IReduxState } from "../../../redux/store";

export function selectCurrentThemeLocation(state: IReduxState) {
  return state.theme.current;
}
